<script setup lang="ts">
import { useSocialProviders } from '@/composables/socialProviders';

defineProps<{
	label: string,
}>();

const socialProviders = useSocialProviders();
</script>
<template>
	<div class="part-social-login">
		<div v-if="label" class="part-social-login__label">{{ label }}</div>
		<slot />
		<ul class="part-social-login__list">
			<li class="part-social-login__item">
				<span
					class="part-social-login__link"
					@click="socialProviders.auth('telegram')"
				>
					<img src="/images/telegram.svg" class="part-social-login__icon" />
				</span>
			</li>
			<li class="part-social-login__item">
				<span
					class="part-social-login__link"
					@click="socialProviders.auth('google')"
				>
					<img src="/images/google.svg" class="part-social-login__icon" />
				</span>
			</li>
		</ul>
	</div>
</template>

<style lang="scss">
.part-social-login {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1.6rem 2.5rem;
	border-radius: 1.6rem;
	gap: 2rem;
	background-color: var(--color-panel);

	@include theme-dark {
		box-shadow: inset 1px 1px 1px 0px rgba(255,255,255,0.12);
	}

	@include min-desktop {
		gap: 4rem;
	}

	&__list {
		display: flex;
		gap: 1.6rem;
		@include min-desktop {
			gap: 2rem;
		}
	}

	&__label {
		color: rgba(var(--color-text-rgb), 0.5);
		@include theme-dark {
			color: var(--color-active);
		}
		@include min-desktop {
			@include font-16-pro-medium;
		}
	}

	&__link {
		display: block;
		cursor: pointer;
		width: inherit;
		height: inherit;
		transition: ease 0.2s;
		&:hover {
			transform: scale(1.05);
		}
	}

	&__item {
		display: block;
		width: 32px;
		height: 32px;
	}
}
</style>
